<form [formGroup]="form" class="mat-typography">
    <table>
        <tr>
            <th>Field</th>
            <th>Current Value</th>
            <th>Desired Value</th>
            <th>Status</th>
        </tr>

        <tr>
            <td>State</td>
            <td>{{data?.state}}</td>
            <td>
                <mat-form-field appearance="fill">
                    <mat-label>State</mat-label>
                    <mat-select formControlName="state">
                        <mat-option [value]="'enabled'">Enabled</mat-option>
                        <mat-option [value]="'disabled'">Disabled</mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
            <td>
                <sway-baseline-status [hasError]="errorsString.includes('state!')"></sway-baseline-status>
            </td>
        </tr>

        <ng-container *ngIf="form.get('state')?.value === 'enabled'">
            <tr>
                <td>
                    <div class="info-wrapper">
                        Allow self-service set up
                        <mat-icon [matTooltip]="'Determines whether users can register new FIDO2 security keys on their own.'">info</mat-icon>
                    </div>
                </td>
                <td>{{data?.isSelfServiceRegistrationAllowed ? 'Yes' : 'No'}}</td>
                <td>
                    <mat-form-field appearance="fill">
                        <mat-label>Allow self-service set up</mat-label>
                        <mat-select formControlName="isSelfServiceRegistrationAllowed">
                            <mat-option [value]="true">Yes</mat-option>
                            <mat-option [value]="false">No</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td>
                    <sway-baseline-status [hasError]="errorsString.includes('isSelfServiceRegistrationAllowed!')"></sway-baseline-status>
                </td>
            </tr>

            <tr>
                <td>
                    <div class="info-wrapper">
                        Enforce attestation
                        <mat-icon [matTooltip]="'Determines whether attestation must be enforced for FIDO2 security key registration.'">info</mat-icon>
                    </div>
                </td>
                <td>{{data?.isAttestationEnforced ? 'Yes' : 'No'}}</td>
                <td>
                    <mat-form-field appearance="fill">
                        <mat-label>Enforce attestation</mat-label>
                        <mat-select formControlName="isAttestationEnforced">
                            <mat-option [value]="true">Yes</mat-option>
                            <mat-option [value]="false">No</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td>
                    <sway-baseline-status [hasError]="errorsString.includes('isAttestationEnforced!')"></sway-baseline-status>
                </td>
            </tr>

            <ng-container formGroupName="keyRestrictions">
                <tr>
                    <td>
                        <div class="info-wrapper">
                            Enforce key restrictions
                            <mat-icon [matTooltip]="'Controls whether key restrictions are enforced on FIDO2 security keys, limiting which authenticators can be used.'">info</mat-icon>
                        </div>
                    </td>
                    <td>{{data?.keyRestrictions?.isEnforced ? 'Yes' : 'No'}}</td>
                    <td>
                        <mat-form-field appearance="fill">
                            <mat-label>Enforce key restrictions</mat-label>
                            <mat-select formControlName="isEnforced">
                                <mat-option [value]="true">Yes</mat-option>
                                <mat-option [value]="false">No</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </td>
                    <td>
                        <sway-baseline-status [hasError]="errorsString.includes('isEnforced!')"></sway-baseline-status>
                    </td>
                </tr>

                <ng-container *ngIf="form.get('keyRestrictions')?.get('isEnforced')?.value">
                    <tr>
                        <td>Restrict specific keys</td>
                        <td>{{data?.keyRestrictions?.enforcementType}}</td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-label>Restriction type</mat-label>
                                <mat-select formControlName="enforcementType">
                                    <mat-option [value]="'allow'">Allow</mat-option>
                                    <mat-option [value]="'block'">Don't allow</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <sway-baseline-status [hasError]="errorsString.includes('enforcementType!')"></sway-baseline-status>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div class="info-wrapper">
                                AAGUIDs
                                <mat-icon [matTooltip]="'List of Authenticator Attestation GUIDs (AAGUIDs) to allow or block.'">info</mat-icon>
                            </div>
                        </td>
                        <td>
                            <div *ngFor="let aaguid of data?.keyRestrictions?.aaGuids">{{ aaguid }}</div>
                            <div *ngIf="!data?.keyRestrictions?.aaGuids?.length">None</div>
                        </td>
                        <td>
                            <app-fido2-aaguid-list formControlName="aaGuids"></app-fido2-aaguid-list>
                            <mat-error *ngIf="form.get('keyRestrictions')?.hasError('aaGuidsRequired')">
                                At least one AAGUID is required when key restrictions are enforced.
                            </mat-error>
                        </td>
                        <td>
                            <sway-baseline-status [hasError]="errorsString.includes('aaGuids!')"></sway-baseline-status>
                        </td>
                    </tr>
                </ng-container>
            </ng-container>
        </ng-container>
    </table>

    <div class="mt-4" *ngIf="form.get('state')?.value === 'enabled'">
        <app-authentication-method-policy-targets
            [readOnly]="readOnly"
            [groups]="groups$ | async"
            [tenantId]="tenant_id"
            [form]="form"
            [policy]="data"
            [item]="baselineTemplateItem"
            [errorsString]="errorsString">
        </app-authentication-method-policy-targets>
    </div>
</form>
